// firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, RecaptchaVerifier, signInWithPhoneNumber } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getMessaging, isSupported } from 'firebase/messaging';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDS-vprOPZEekrS34ybegxfjAMEpv65Slc",
  authDomain: "gn-app-prod.firebaseapp.com",
  databaseURL: "https://gn-app-prod-default-rtdb.firebaseio.com",
  projectId: "gn-app-prod",
  storageBucket: "gn-app-prod.firebasestorage.app",
  messagingSenderId: "763342331487",
  appId: "1:763342331487:web:c0c34d2a54439421cd05ea",
  measurementId: "G-KEWLGS4DB2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const provider = new GoogleAuthProvider();
// 🛡️ Prevent unsupported error
let messagingPromise = isSupported().then((supported) => {
  if (supported) {
 return getMessaging(app);
  } else {
console.warn("Firebase Messaging is not supported in this browser.");
 return null;
  }
});
export { auth, RecaptchaVerifier, signInWithPhoneNumber, db, messagingPromise, storage, provider }